import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { EventData } from '../providers/event';
import { Observable } from 'rxjs/Observable';

@Pipe({
  name: 'translateConfig',
  pure: true
})
@Injectable()
export class TranslateConfigPipe implements PipeTransform {

  constructor(
    private eventData: EventData
  ) { }

  transform(moduleName: any, clientId: string, eventId: string): Observable<any> {
    return this.eventData.getEventConfigByModule(clientId, eventId, moduleName);
  }
}
// end file



// WEBPACK FOOTER //
// ./src/pipes/translate-config.ts